import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Users, Award, Building2, Map } from 'lucide-react';
import { useCmsContent } from '../../hooks/useCmsContent';

const StorySection = () => {
  const { getContentValue, loading } = useCmsContent({ section: 'about' });
  
  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative aspect-video"
          >
            <div className="relative z-10 rounded-lg overflow-hidden shadow-xl">
              <img 
                src="/images/agenzia5.jpeg"
                alt="Scandicci panorama" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -top-10 -left-10 bg-primary/10 w-full h-full rounded-lg -z-10"></div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-secondary uppercase tracking-wider font-semibold">La Nostra Storia</span>
            <h2 className="text-4xl font-monomakh text-primary mt-2 mb-6">Un'Agenzia Immobiliare<br/>Radicata nel Territorio</h2>
            <p className="text-gray-600 mb-6 text-lg leading-relaxed">
              La nostra storia inizia nel {getContentValue('anno_fondazione') || '2017'}, quando abbiamo aperto le porte della nostra agenzia immobiliare a Scandicci, 
              con una missione chiara: offrire un servizio personalizzato, trasparente e professionale a chi cerca 
              o vuole vendere casa.
            </p>
            <p className="text-gray-600 mb-8 text-lg leading-relaxed">
              Da dicembre 2024, dopo anni di esperienza come affiliati, abbiamo scelto l'indipendenza per darvi 
              un servizio ancora più autentico e personale. La nostra profonda conoscenza del territorio non è solo 
              professionale, ma personale: conosciamo ogni angolo, ogni storia, ogni possibilità che questo territorio offre.
            </p>
            
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div>
                <div className="flex items-center mb-4">
                  <Map className="h-5 w-5 text-primary mr-2" />
                  <h3 className="text-xl font-semibold text-primary">Territorio</h3>
                </div>
                <p className="text-gray-600">
                  La nostra esperienza locale ti garantisce la migliore valutazione del mercato
                </p>
              </div>
              
              <div>
                <div className="flex items-center mb-4">
                  <Users className="h-5 w-5 text-primary mr-2" />
                  <h3 className="text-xl font-semibold text-primary">Clienti</h3>
                </div>
                <p className="text-gray-600">
                  Oltre {getContentValue('clienti_soddisfatti') || '300'} famiglie hanno trovato la loro casa ideale grazie alla nostra consulenza.
                </p>
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row gap-6">
              <div className="bg-primary/5 p-6 rounded-lg">
                <div className="flex items-center mb-3">
                  <Building2 className="h-8 w-8 text-secondary mr-3" />
                  <h3 className="text-lg font-semibold text-secondary">Indipendenza</h3>
                </div>
                <p className="text-gray-600">
                  Agenzia indipendente dal 2024, per un servizio personalizzato e flessibile.
                </p>
              </div>
              
              <div className="bg-primary/5 p-6 rounded-lg">
                <div className="flex items-center mb-3">
                  <Award className="h-8 w-8 text-secondary mr-3" />
                  <h3 className="text-lg font-semibold text-secondary">Esperienza</h3>
                </div>
                <p className="text-gray-600">
                  Dal 2017 nel mercato immobiliare locale con risultati comprovati.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;